// Single source of truth for the Donate CTA destination.
// External PayPal donation portal.
export const DONATE_URL = 'https://www.paypal.com/donate?campaign_id=5A77N45FF9Y6J';

// Spread these props onto any <a> / Nav.Link that points to the donation portal
// so it opens in a new tab safely.
export const DONATE_LINK_PROPS = {
  href: DONATE_URL,
  target: '_blank',
  rel: 'noopener noreferrer',
};
